/**
 * Input limits shared by the Physio center profile page and Physio Onboarding, so both forms
 * accept exactly the same data.
 *
 * The "About the Center" limit matches the doctor bio limit (500) and keeps the text readable
 * in the patient app's center card and profile.
 */
export const BIO_MAX_LENGTH = 500;
